import React from 'react';
import {Link} from 'react-router-dom';

import {Scopes} from 'Services';

export default ({options, active, baseRoute}) => (
    <div className="hidden sm:block">
        <nav className="flex">
            {options.map((option) => {
                if (option.scopes === undefined || Scopes.has(option.scopes)) {
                    return (
                        <Link
                            key={option.id}
                            to={`${baseRoute}/${option.id}`}
                            className={
                                `px-3 py-2 font-medium text-sm leading-5 rounded-md
                                hover:text-gray-700 focus:outline-none
                                focus:text-gray-700
                                ${option.id === active ? 'text-gray-700 bg-gray-200' : ''}`
                            }>
                            {option.display}{option.display_count ? ` (${option.display_count})` : ''}
                        </Link>
                    );
                }
            })}
        </nav>
    </div>
);

